/* eslint-disable */
import { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";

import { logout } from "../../store/authSlice";

/**
 * Middleware that intercepts HTTP 401 Unauthorized and 403 Forbidden responses and dispatches
 * the `logout` action.
 */
const rtkQueryAuthGuard: Middleware =
  (api: MiddlewareAPI) => (next) => async (action: any) => {
    if ([401, 403].includes(action?.payload?.originalStatus)) {
      api.dispatch(logout());
    }

    return next(action);
  };

export default rtkQueryAuthGuard;